import { Modal } from 'antd';

import colors from '../../constants/Colors';

import { safeExtractFromObject } from '../../helpers/helpers';

import store from '../../state/store';

const getButton = (color, disabled) => ({
  backgroundColor: color,
  borderColor: color,
  color: 'white',
  borderRadius: 18,
  width: 110,
  height: 36,
  opacity: disabled ? 0.5 : 1,
});

const { confirm } = Modal;
export default ({
  title,
  onOk,
  okText,
  onCancel,
  cancelText,
  style,
  content,
  hideFooter = false,
  hideCancel = false,
  afterClose = () => {},
  maskColor,
  maskClosable = true,
  keyboard = true,
  okButtonDisabled = false,
  okButtonStyle = {},
  cancelButtonStyle = {},
  additionalOptions = {},
  zIndex = 1000,
}) => {
  const state = store.getState();
  const hasRedesign = safeExtractFromObject(state, 'settings.company.settings.uxRedesignPt1');

  const options = {
    ...style,
    maskClosable,
    keyboard,
    wrapClassName: 'myModal',
    title,
    content,
    onCancel,
    cancelText,
    onOk,
    okText,
    centered: true,
    zIndex,
    okButtonProps: {
      style: {
        ...getButton(hasRedesign ? colors.BLUE_700 : colors.ONTRACCR_RED, okButtonDisabled),
        ...hasRedesign ? {
          fontFamily: 'open-sans-600, sans-serif',
        } : {},
        ...okButtonStyle,
      },
      disabled: okButtonDisabled,
    },
    cancelButtonProps: {
      style: {
        ...getButton('gray'),
        ...hasRedesign ? {
          backgroundColor: 'white',
          color: colors.REDESIGN_BUTTON_UNSELECTED_TEXT,
          borderColor: colors.GRAY_400,
          fontFamily: 'open-sans-600, sans-serif',
        } : {},
        ...cancelButtonStyle,
      },
    },
    afterClose,
    ...additionalOptions,
  };
  if (hideCancel) options.cancelButtonProps = { style: { display: 'none' }, className: 'modal-footer-hidden-button' };
  if (hideFooter) {
    options.okButtonProps = { style: { display: 'none' }, className: 'modal-footer-hidden-button' };
    options.cancelButtonProps = { style: { display: 'none' }, className: 'modal-footer-hidden-button' };
  }

  if (maskColor) {
    options.maskStyle = {
      backgroundColor: maskColor,
    };
  }
  return confirm(options);
};
